import { createSlice } from "@reduxjs/toolkit";

const orderSlice = createSlice({
    name: 'order',
    initialState:{
        loading:true,
        orderDetails:{},
        userOrder: [],
        error:null
    },
    reducers:{
        createOrderRequest(state,action){
            return{
                ...state,
                loading: true,
            }
        },
        createOrderSuccess(state,action){
            return{
                ...state,
                loading: false,
                order: action.payload.order
            }
        },
        createOrderFail(state,action){
            return{
                ...state,
                loading:false,
                error: action.payload
            }
        },
          clearOrderError(state, action) {
            return {
                ...state,
                error: null
            }
        },
        userOrdersRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        userOrdersSuccess(state, action) {
            return {
                ...state,
                loading: false,
                userOrders: action.payload
            }
        },
        userOrdersFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        },
        orderDetailRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        orderDetailSuccess(state, action) {
            return {
                ...state,
                loading: false,
                orderDetail: action.payload.order
            }
        },
        orderDetailFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        }
    }
});

const {actions, reducer} = orderSlice;

export const {
    createOrderRequest,
    createOrderSuccess,
    createOrderFail,
    userOrdersRequest,
    userOrdersSuccess,
    userOrdersFail,
    orderDetailRequest,
    orderDetailSuccess,
    orderDetailFail,
    clearOrderError
} = actions;

export default reducer;